import { useEffect } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import type { BMIToolPageProps } from './form'
import type { Props as BmiResultProps } from './result'
import { addResultToLink } from '../helpers'

const BMIToolResultPageComponent = dynamic<BmiResultProps>(
  () => import('./result'),
)

const BMIToolPageComponent = dynamic<BMIToolPageProps>(() => import('./form'))

export type InputError = {
  age: string
  weight: string
  height: string
}

export type Props = BMIToolPageProps | BmiResultProps

export const BMIToolPage = ({ type = 'form', ...props }: Props) => {
  const router = useRouter()
  useEffect(() => {
    if (type === 'result' || type === 'records') {
      if (!router.asPath.includes('?result=1')) {
        const newPath = addResultToLink(router.asPath)
        router.push(newPath, newPath, { shallow: true })
      }
    }
  }, [type])
  switch (type) {
    case 'result':
      return <BMIToolResultPageComponent {...(props as BmiResultProps)} />

    default:
      return <BMIToolPageComponent {...(props as BMIToolPageProps)} />
  }
}
